const devEvns = {
  baseUrl: 'https://test-api.truckerpath.com/',
  mixpanelToken: 'ab6f5a3ff2033649dee52606472c4e70',
  url: 'https://command-fleet.qa-websit.truckerpath.com/',
  gtagId: "G-0RWJRYQC28"
}
const prodEvns = {
  baseUrl: 'https://api.truckerpath.com/',
  mixpanelToken: 'e7faf9dc7135978329a67fbff2a6ebab',
  url: 'https://command.truckerpath.com/',
  gtagId: "G-59SHT3LNB4"
}

export const envs = process.env.REACT_APP_ENV === 'production' ? prodEvns : devEvns

